import { carouselItems } from '@/mocks/home';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            本周最受关注的深度爆料专题，每日更新最新进展
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <article
              key={item.id}
              className={`group relative bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative ${idx === 0 ? 'h-48 md:h-64' : 'h-40 md:h-48'} overflow-hidden`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-1 rounded-md bg-primary-500 text-white text-xs font-semibold">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="px-2 py-1 rounded-md bg-accent-500/90 text-white text-xs font-semibold">
                      热门
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className={`font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 ${
                  idx === 0 ? 'text-lg md:text-xl' : 'text-base'
                }`}>
                  {item.title}
                </h3>
                <p className={`mt-2 text-foreground-600 leading-relaxed line-clamp-2 ${
                  idx === 0 ? 'text-sm' : 'text-xs md:text-sm'
                }`}>
                  {item.excerpt}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs text-primary-500 font-medium">阅读全文 →</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}